<template>
	<!--v-container grid-list-md text-xs-center-->
		<div v-if="!isUploading"> 
	 		<v-card v-for="(f, i) in files" style="margin-bottom:2em;" :key="i">
	 			<v-card-title>{{f.name}}</v-card-title>
	 			<audio v-if="f.uploaded === true" controls>
	 				<source :src="paths['audio'] + '/' + route.name + '/' +  parseFile(f.name)" :type="f.type">
	 				Your browser doesnt support audio element
	 			</audio>
	 			<v-container v-if="f.uploaded && f.matchingImage && !f.uploadImageAnswer" justify-center>
	 				<v-img
					 	:src="paths['images'] + '/' + route.name + '/' +  parseFile(f.matchingImage)"
					 	aspect-ratio="1"
					></v-img>

					<!--v-btn small color="success">
						<v-icon>check_circle</v-icon>
						{{translater.__('Use this')}}
					</v-btn-->
					<v-btn flat @click="setFileUploadImageAnswer(true, f)"  small color="primary">
						<v-icon>backup</v-icon>&nbsp;
						{{translater.__('Upload', 'routes')}}
					</v-btn>
	 			</v-container>
	 			<!--v-container v-if="f.uploaded && f.matchingImage && f.uploadImageAnswer === true">
	 				<Upload :upload-audio-task-answer-image="true" :audio-file="f.name" change-name="change_name" />
	 				<v-btn color="primary" @click="setFileUploadImageAnswer(false, f)">
	 					<v-icon>cancel</v-icon>
	 					{{translater.__('Cancel')}}
	 				</v-btn>
	 			</v-container-->
	 			<v-container v-if="(f.uploaded && !f.matchingImage) || (f.uploaded && f.matchingImage && f.uploadImageAnswer === true)">
	 				
	 				<!--Upload :upload-audio-task-answer-image="true" :audio-file="f.name" :change-name="undefined"  />
	 				<v-btn v-if="f.uploadImageAnswer === true" color="primary" @click="setFileUploadImageAnswer(false, f)">
	 					<v-icon>cancel</v-icon>
	 					{{translater.__('Cancel')}}
	 				</v-btn-->
					<Upload
						upload="files/uploadAudioTaskAnswerImage"
						:payload="{audio: f.name}"
						:show-upload-list="false"
						instruction-text="You can upload an image (png) file"
						:max-files="1"
						:validate-num-of-files="answerImageNumValidator"
					></Upload>
					<div v-if="typeof audioTaskAnswerImagesToUpload !== 'undefined'
					&& typeof audioTaskAnswerImagesToUpload[f.name] !== 'undefined'
					&& typeof audioTaskAnswerImagesToUpload[f.name].error !== 'undefined'
					">

						{{audioTaskAnswerImagesToUpload[f.name].error.text}}
					</div>


					<v-btn flat small v-if="f.uploadImageAnswer === true" color="primary" @click="setFileUploadImageAnswer(false, f)">
						<v-icon>cancel</v-icon>
						{{translater.__('Cancel')}}
					</v-btn>

	 			</v-container>
	 			
		        
	 			
		 		

	 			



	 			 <v-text-field v-if="newTask.answers"
	 			 	@keyup="setAnswerContent($event, f.name)"
	 			 	:label="translater.__('Answer', 'tasks')"
	 			 	:value="newTask.answers[f.name]"
	 			 >
	 			 	
	 			 </v-text-field>


	 		</v-card>
	 	</div>
		 	
	<!--/v-container-->
</template>

<style scoped>

</style>

<script>
	
	import {parseFileName} from '../../../tools';
	import Upload from './Upload';
	
	export default {
		name: 'AudioAnswers',
		components: {Upload},
		data()
		{
			return{}
		},

		created(){
			/*window.vm.$on('fileUploaded', () => {
				console.log("fileUploaded")
				this.$forceUpdate();
			});*/

			/*window.vm.$on('uploadImageAnswerSet', () => {
				this.$forceUpdate();
			})*/

			
		},

		methods: {

			answerImageNumValidator(files, cb)
			{
				let valid = false;
				if(files.length === 1){
					valid = true;
				}
				cb(valid)

			},

			parseFile(f)
			{
				return parseFileName(f)
			},

			setAnswerContent(e, name)
			{
				this.$store.dispatch('checkpoints/setNewTaskAnswer', {value: e.target.value, name: name})

				this.$store.dispatch('checkpointsValidator/validateAudioTask')
				.then((valid) => {
					//console.log("########audioAnswers::valid", valid)
					this.$store.commit('checkpointsValidator/setValid', valid);
				})
			},

			setFileUploadImageAnswer(value,file)
			{
				this.$store.dispatch('files/setUploadImageAnswer', {file: file, value: value});
			}

			
		},

		computed: {

			/*uploadImageAnswer: {
				get()
				{
					return this.$store.getters['checkpoints/uploadImageAnswer'];
				},

				set(value)
				{
					this.$store.dispatch('checkpoints/setUploadImageAnswer', value)
				}
			}, */

			translater: {
				get()
				{
					return this.$store.getters['translate/translater'];
				}
			},

			files: {
				get()
				{
					return this.$store.getters['files/filesToUpload'];
				}
			},

			paths: {
				get()
				{	
					let p = this.$store.getters['checkpoints/fullPaths'];
					
					return p;
				}
			},

			route: {
				get()
				{
					return this.$store.getters['routes/route']
				}
			},

			newTask: {
				get()
				{
					return this.$store.getters['checkpoints/newTask']
				}
			},

			/*imageExists:{
				get()
				{
					return this.$store.getters['checkpoints/existingImages']
				}
			},
			*/

			isCheckingIfExists:{
				get()
				{
					return this.$store.getters['files/isCheckingIfExists']
				}
			},

			isUploading:
			{
				get()
				{
					return this.$store.getters['files/isUploading'];
				}
			},

			audioTaskAnswerImagesToUpload: {
				get()
				{
					return this.$store.getters['files/audioTaskAnswerImagesToUpload']
				}

			}

		}
	}
</script>

